export default "__VITE_ASSET__bd20d1b8__"